import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
type ContainerProps = {
  onChangeBerth?: (value: string) => void;
};
export const useContainer = t0 => {
  const $ = _c(4);
  const {
    onChangeBerth
  } = t0;
  let t1;
  if ($[0] !== onChangeBerth) {
    t1 = berthId => {
      onChangeBerth?.(berthId);
    };
    $[0] = onChangeBerth;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChangeBerth = t1;
  let t2;
  if ($[2] !== handleChangeBerth) {
    t2 = {
      handleChangeBerth
    };
    $[2] = handleChangeBerth;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};